import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import * as S from "./styled";

/**
 * @deprecated please use @streeteasy/design-system/form/RadioInput instead
 */
export const RadioButton = forwardRef((props, ref) => (
  <S.InputRadio {...props} ref={ref} />
));

RadioButton.defaultProps = {
  theme: "default"
};

RadioButton.propTypes = {
  theme: PropTypes.oneOf(["blueDot", "default"])
};

RadioButton.displayName = "RadioButton";

export default RadioButton;
